package com.exura.features.plandefinition.domain.builder

import com.exura.features.firebase.domain.model.SerializableDomainModel

/**
 * Base interface for all builders
 */
interface PlanElementBuilder<T : SerializableDomainModel> {
    var isChanged: Boolean

    var buildResultNeedRecalculation: Boolean
    var cachedBuildResult: T?

    fun validate(): List<String>

    fun validateFields(fields: Map<String, BuilderField<*>>): List<String> {
        val messages = mutableListOf<String>()
        fields.forEach { entry ->
            val fieldsName = entry.key
            val field = entry.value
            try {
                field.validate()
            } catch (e: IllegalStateException) {
                messages.add("${fieldsName}: ${e.message}")
            }
        }
        return messages.toList()
    }

    fun build(): T
    fun markSaved() = apply {
        isChanged = false
        println(isChanged)
    }

    fun updateChangedState(setResult: Boolean) {
        isChanged = isChanged || setResult
    }

    fun save(onSave: (() -> Unit)? = null): T? {
        val m = validate()
        if(m.isEmpty()) {
            throw IllegalStateException(m.toString())
        }
        if(isChanged) {
            markSaved()
            onSave?.invoke()
            return rebuild()
        } else {
            return null
        }
    }

    fun rebuild(): T {
        return if (buildResultNeedRecalculation || cachedBuildResult == null) {
            cachedBuildResult = build()
            buildResultNeedRecalculation = false
            cachedBuildResult!!
        } else {
            cachedBuildResult!!
        }
    }

    fun updateBuildState(setResult: Boolean) {
        buildResultNeedRecalculation = buildResultNeedRecalculation || setResult
    }
}
